// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"942":"6376511ce607b7ad","1861":"e5cb8035528afb42","2554":"a33006ddf431ce6e","4112":"a3ede44e6a0beb25","4817":"a101d48440782d5f","7399":"82e07e7f138538f7","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};